/**
 * @flow
 * @relayHash b1a6fb159b53ca94f6ce60d6ade5a7bb
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type SubjectsAdminQueryResponse = {|
  +master: ?{| |};
|};
*/


/*
query SubjectsAdminQuery {
  master {
    ...Subjects_master
  }
}

fragment Subjects_master on Master {
  allSubjects(first: 10) {
    edges {
      node {
        id
        name
        description
      }
    }
  }
}
*/

const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SubjectsAdminQuery",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Master",
        "name": "master",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "Subjects_master",
            "args": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "SubjectsAdminQuery",
  "query": {
    "argumentDefinitions": [],
    "kind": "Root",
    "name": "SubjectsAdminQuery",
    "operation": "query",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Master",
        "name": "master",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 10,
                "type": "Int"
              }
            ],
            "concreteType": "SubjectConnection",
            "name": "allSubjects",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "SubjectEdge",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "Subject",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "id",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "name",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "description",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "allSubjects{\"first\":10}"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": "query SubjectsAdminQuery {\n  master {\n    ...Subjects_master\n  }\n}\n\nfragment Subjects_master on Master {\n  allSubjects(first: 10) {\n    edges {\n      node {\n        id\n        name\n        description\n      }\n    }\n  }\n}\n"
};

module.exports = batch;



// WEBPACK FOOTER //
// ./src/components/master/__generated__/SubjectsAdminQuery.graphql.js